import React from 'react';
import { Col, Layout, Row, Typography, Button } from 'antd';
import GreetingsTop from '../../../components/Admin/GreetingsTop/GreetingsTop';
import { useHistory } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import ClarificationDetail from '../../../components/Admin/Clarifications/ClarificationDetail/ClarificationDetail';

export default function ClarificationsDetail() {
    return (
        <Layout>
            <GreetingsTop />

            <HeaderTop />

            <div className="billing__container">
                <ClarificationDetail />
            </div>
        </Layout>
    );
}

function HeaderTop() {
    let history = useHistory();
    const { Title } = Typography;
    return (
        <div className="billing__container">
            <Row className="header-top">
                <Col xs={23} className="header-top__left">
                    <Row>
                        <Col xs={20}>
                            <Title level={3}>Aclaraciones</Title>
                        </Col>

                        <Col xs={2}>
                            <Button
                                type="link"
                                onClick={() => history.goBack()}
                            >
                                <ArrowLeftOutlined /> Atrás
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    );
}
